const LockIcon = () => {
  return (
    <svg
      aria-hidden="true"
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_12058_18164)">
        <circle cx="28" cy="28" r="28" fill="#CCCCFF" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M28.5 18.4286C27.5838 18.4286 26.7051 18.7898 26.0573 19.4328C25.4094 20.0758 25.0455 20.9478 25.0455 21.8571V23.5714H31.9545V21.8571C31.9545 20.9478 31.5906 20.0758 30.9427 19.4328C30.2949 18.7898 29.4162 18.4286 28.5 18.4286ZM21.5909 21.8571V23.5714C20.9038 23.5714 20.2447 23.8423 19.7589 24.3246C19.273 24.8068 19 25.4609 19 26.1429V36.4286C19 37.1106 19.273 37.7646 19.7589 38.2468C20.2447 38.7291 20.9038 39 21.5909 39H35.4091C36.0962 39 36.7553 38.7291 37.2411 38.2468C37.727 37.7646 38 37.1106 38 36.4286V26.1429C38 25.4609 37.727 24.8068 37.2411 24.3246C36.7553 23.8423 36.0962 23.5714 35.4091 23.5714V21.8571C35.4091 20.0385 34.6812 18.2944 33.3855 17.0084C32.0898 15.7224 30.3324 15 28.5 15C26.6676 15 24.9102 15.7224 23.6145 17.0084C22.3188 18.2944 21.5909 20.0385 21.5909 21.8571ZM28.5 33.4286C28.7835 33.4286 29.0643 33.3731 29.3262 33.2655C29.5882 33.1578 29.8262 32.9999 30.0267 32.8009C30.2272 32.602 30.3862 32.3657 30.4947 32.1058C30.6032 31.8458 30.6591 31.5671 30.6591 31.2857C30.6591 31.0043 30.6032 30.7257 30.4947 30.4657C30.3862 30.2057 30.2272 29.9695 30.0267 29.7705C29.8262 29.5715 29.5882 29.4137 29.3262 29.306C29.0643 29.1983 28.7835 29.1429 28.5 29.1429C27.9274 29.1429 27.3782 29.3686 26.9733 29.7705C26.5684 30.1723 26.3409 30.7174 26.3409 31.2857C26.3409 31.854 26.5684 32.3991 26.9733 32.8009C27.3782 33.2028 27.9274 33.4286 28.5 33.4286Z"
          fill="#330066"
        />
      </g>
      <defs>
        <clipPath id="clip0_12058_18164">
          <rect width="56" height="56" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default LockIcon
